import { Theme } from '@eversports/react-components/design-tokens/theme'
import useMediaQuery from '@eversports/react-components/design-tokens/useMediaQuery'
import useTheme from '@eversports/react-components/design-tokens/useTheme'
import Flex from '@eversports/react-components/primitives/Flex'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { Card, hasActivityBasedParticipationRules, splitUsagesByActivityScope } from '../../typings/Product'

import CardModalContentDetails from './CardModalContentDetails'
import ValidActivities from './ValidActivities'

const useStyles = makeStyles((theme: Theme) => ({
  cardRightContainer: {
    flex: 0.3,
    [theme.breakpoints.down('md')]: {
      flex: '1 0 100%',
    },
  },
}))

interface Props {
  product: Card
}

const CardModalContent: React.FC<React.PropsWithChildren<Props>> = ({ product }) => {
  const theme = useTheme()
  const classes = useStyles()
  const isInMobileView = useMediaQuery(theme.breakpoints.down('md'))
  const { activityUsages } = splitUsagesByActivityScope(product.usages)
  const hasActivityBasedRules = hasActivityBasedParticipationRules(activityUsages, product.unlimitedUsages)

  const details = (
    <CardModalContentDetails
      product={product}
      hasActivityBasedParticipationRules={hasActivityBasedRules}
      isInMobileView={isInMobileView}
    />
  )

  if (!hasActivityBasedRules) {
    return details
  }

  return (
    <Flex flexDirection={['column', 'column', 'row']} verticalSpacing="wide" flexWrap="wrap">
      {details}
      <Flex flexDirection="column" verticalSpacing="wide" className={classes.cardRightContainer}>
        <ValidActivities
          activities={product.activities}
          activityUsages={activityUsages}
          unlimitedUsages={product.unlimitedUsages}
          validityDuration={product.validity?.duration ?? null}
        />
      </Flex>
    </Flex>
  )
}

export default CardModalContent
